// Import: Middleware Action & Custom Types
import {
    CLEAN_BACKOFFICE_LEAD_STATUS,
    CLEAN_BACKOFFICE_LEAD_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const cleanBackofficeLeadStatusAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_BACKOFFICE_LEAD_STATUS,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_BACKOFFICE_LEAD_STATUS_ERROR,
            payload: undefined,
        });
    }
};
